<template>
  <!-- Mobile: reuse the control's ConditionGuidance gallery. Desktop: the condensed funnel carousel. Both are media-query hydrated so the inactive variant is never hydrated. -->
  <LazyHydrationConditionGuidance
    class="md:hidden"
    :brand
    :content
    :hydrate-on-media-query="`(max-width: ${DESKTOP_BREAKPOINT - 1}px)`"
    :tracking-model
  />
  <LazyHydrationCondensedFunnelGradesCarousel
    class="hidden md:flex mb-16"
    :brand
    :content
    :hydrate-on-media-query="`(min-width: ${DESKTOP_BREAKPOINT}px)`"
    :tracking-model
  />
</template>

<script lang="ts" setup>
import { defineLazyHydrationComponent } from '#imports'

import type { Picker } from '@backmarket/http-api/src/api-specs-navigation-experience/product/pickers'

import { DESKTOP_BREAKPOINT } from '~/scopes/product-core/components/presentationals/CustomizationFunnelCondensed/CustomizationFunnelCondensed.constants'

const LazyHydrationConditionGuidance = defineLazyHydrationComponent(
  'mediaQuery',
  () =>
    import('~/scopes/product-core/components/presentationals/CustomizationFunnel/components/ConditionGuidance/ConditionGuidance.vue'),
)
const LazyHydrationCondensedFunnelGradesCarousel = defineLazyHydrationComponent(
  'mediaQuery',
  () =>
    import('~/scopes/product-core/components/presentationals/CustomizationFunnelCondensed/components/CondensedFunnelGradesCarousel/CondensedFunnelGradesCarousel.vue'),
)

withDefaults(
  defineProps<{
    brand?: string
    content?:
      | NonNullable<NonNullable<Picker['sideContentV2']>['content']>
      | undefined
    trackingModel?: string
  }>(),
  {
    brand: '',
    content: undefined,
    trackingModel: '',
  },
)
</script>
